import { PAGE_NAMES as MYT_PAGE_NAMES } from 'tradera/apps/my-tradera/app/constants/page';

export type Survey = {
    survey: string;
    supportURL?: string;
};

export const SURVEYS: Record<string, Survey> = {
    general: {
        survey: 'tradera/hur-tycker-du-att-det-fungerar-att-anvanda-tradera',
        supportURL: 'https://www.tradera.com/support/'
    },
    language: {
        survey: 'tradera/english-translation---rate-your-experience'
    },
    cardVerification: {
        survey: 'tradera/vad-fick-dig-att-avbryta-kortverifieringen'
    },
    [MYT_PAGE_NAMES.SellerSold]: {
        survey: 'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-salda-annonser'
    },
    [MYT_PAGE_NAMES.Overview]: {
        //https://tradera.qualtive.io/questions/hur-fungerar-nya-oversikten/
        survey: 'tradera/hur-fungerar-nya-oversikten'
    },
    boughtPage: {
        survey: 'tradera/nya-kopta-listan-hur-fungerar-den-for-dig'
    },
    soldPage: {
        survey: 'tradera/nya-salda-listan-hur-fungerar-den-for-dig'
    },
    listingsPage: {
        survey: 'tradera/dina-annonser-sidan-hur-fungerar-den-for-dig'
    },
    biddingPage: {
        survey: 'tradera/vad-tycker-du-om-nya-sidan-for-budgivningar'
    },
    valuationPage: {
        survey: 'tradera/vad-ar-den-vard-hur-tycker-varderingen-funkar-'
    },
    syiDraftPage: {
        survey: 'tradera/hur-fungerar-det-att-skapa-en-annons'
    },
    payouts: {
        survey: 'tradera/utbetalningar-hur-fungerar-den-for-dig'
    },
    translationImprovements: {
        survey: 'tradera/versattningar-forbattringsforslag'
    },
    shipping: {
        survey: 'tradera/fraktbokning---hur-fungerar-det-fr-dig'
    },
    selectShipping: {
        survey: 'tradera/hur-fungerar-det-att-valja-och-boka-frakt'
    },
    invoice: {
        survey: 'tradera/fakturabetalning-hur-fungerar-den-for-dig'
    },
    syiDescreasePriceOnRestart: {
        survey: 'tradera/vad-tycker-du-om-funktionen-sanka-pris'
    },
    swedishCompanyRegEmail: {
        survey: 'tradera/swedish-company-email'
    },
    purchaseOffer: {
        survey: 'tradera/vad-tycker-du-om-funktionen-prisforslag'
    },
    wardrobeProfile: {
        survey: 'tradera/browse-items-how-does-it-work-for-you'
    },
    picklist: {
        survey: 'tradera/plocklistan'
    },
    magicalSyiPublished: {
        survey: 'tradera/vad-tycker-dom-om-att-vi-fyller-i-annonsen-automatiskt'
    },
    orderInfo: {
        survey: 'tradera/vad-tycker-du-om-sidan-orderinformation'
    },
    disputeBuyerWon: {
        survey: 'tradera/hur-var-din-koparskyddsupplevelse'
    },
    disputeBuyerLost: {
        survey: 'tradera/hur-upplevde-du-ditt-arende-'
    },
    disputeSellerWon: {
        survey: 'tradera/hur-var-ditt-arende-'
    },
    disputeSellerLost: {
        survey: 'tradera/tyck-till-om-arendeprocessen'
    },
    cart: {
        survey: 'tradera/hur-tycker-du-varukorgen-fungerar'
    }
};
